import { useNavigate } from 'react-router-dom';

export function FinalCTA() {
  const navigate = useNavigate();

  const handleAssessment = () => {
    navigate('/property-assessment');
  };

  const handleBookCall = () => {
    navigate('/book-call');
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative py-32 lg:py-40 bg-[#882629] overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827zM5.373 0l-.83.828L5.96 2.243 8.2 0H5.374zM48.97 0l3.657 3.657-1.414 1.414L46.143 0h2.828zM11.03 0L7.372 3.657 8.787 5.07 13.857 0H11.03zm32.284 0L49.8 6.485 48.384 7.9l-7.9-7.9h2.83zM16.686 0L10.2 6.485 11.616 7.9l7.9-7.9h-2.83zm20.97 0l9.315 9.314-1.414 1.414L34.828 0h2.83zM22.344 0L13.03 9.314l1.414 1.414L25.172 0h-2.83zM32 0l12.142 12.142-1.414 1.414L30 .828 17.272 13.556 15.858 12.14 28 0zm0 3.657l10.485 10.485-1.414 1.414L32 6.485 22.929 15.556l-1.414-1.414L32 3.657z' fill='%23FFFFFF' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-white mb-6">
          Not sure what your property qualifies for?
        </h2>
        <p className="text-lg lg:text-xl text-white/90 leading-relaxed mb-12 max-w-2xl mx-auto">
          A short conversation can save you thousands in fees and mistakes. Let's discuss your property and find the right path forward.
        </p>

        <div className="flex flex-wrap justify-center gap-5">
          <button 
            onClick={handleAssessment}
            className="bg-white text-[#882629] px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-50 transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl"
          >
            Check my property eligibility
          </button>
          <button 
            onClick={() => navigate('/revenue-calculator')}
            className="bg-white text-[#882629] px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-50 transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl"
          >
            Estimate my rental revenue
          </button>
          <button 
            onClick={handleBookCall}
            className="border-2 border-white text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
          >
            Book a free intro call
          </button>
        </div>
      </div>
    </section>
  );
}
